<template>
  <div class="main-content">
    <!-- CARDS -->
    <div class="container-fluid">
      <!-- / .row -->
      <div class="row">
        <div class="col-12">
          <!-- Convertions -->
          <b-overlay :show="overlay" rounded="lg" >
            <div class="card mt-5">
              <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">Sick Leave</h4>
              </div>
              <div class="card-body">
                <div class="d-flex justify-content-end mb-3">
                  <label class="align-self-center mb-0 mr-3">Search</label>
                  <b-form-input v-model="searchTerm" class="w-auto" placeholder="Type Here..."></b-form-input>
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="list"
                  :line-numbers="true"
                  :search-options="{
                    enabled: true,
                    externalQuery: searchTerm,
                  }"
                  :pagination-options="{
                    enabled: true,
                    perPage: pageLength,
                  }">
                  <template slot="table-row" slot-scope="props">
                    <div
                      v-if="props.column.field == 'action'"
                      class="text-center"
                    >
                      <button class="btn btn-sm btn-info me-2" title="Detail" @click.prevent="$router.push(`/sick-leave/${props.row.nik}`)">
                        <span class="fe fe-eye"></span>
                      </button>
                    </div>
                  </template>
                  <template slot="pagination-bottom" slot-scope="props">
                    <div class="d-flex justify-content-end">
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="props.total"
                          :per-page="pageLength"
                          first-number
                          last-number
                          align="right"
                          prev-class="prev-item"
                          next-class="next-item"
                          class="m-3"
                          @input="(value) => props.pageChanged({ currentPage: value })"
                        >
                        </b-pagination>
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
      <!-- / .row -->
    </div>
  </div>
  <!-- / .main-content -->
</template>
<style>
  .myTable th, .myTable td {
    border: 1px solid black !important;
  }
</style>
<script>
import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";
import moment from "moment";

export default {
  name: "sickLeaveList",
  computed: {
    columns() {
      return this.$store.getters["sick_leave/columns"];
    },
    list() {
      return this.$store.getters["sick_leave/list"];
    },
  },
  data() {
    return {
      searchTerm: "",
      pageLength: 10,
      params: {},
      overlay: true,
      details: {}
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.$store.dispatch("sick_leave/GET_LIST").finally(() => this.overlay = false)
    },
    formatDate(date) {
      if (date) {
        return moment(date).format("D MMM YY HH:mm:ss");
      }
      return date;
    },
  },
};
</script>